export default {
  subscribePlans: {},
  chosenPlan: {},
  basicSeller: {}
}



// WEBPACK FOOTER //
// ./src/app/pages/subscribe/vuex/state.js